export default class ReadLaterService {
    private static apiUrl: string = '/api/read-later/v2/pages/';

    public static async add(pageId: number, pageUrl: string): Promise<boolean> {
        try {
            const res: Response = await fetch(this.apiUrl, {
                method: 'PUT',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify([{
                    pageId,
                    pageUrl
                }]),
            });

            if (!res.ok) {
                throw new Error('Internal server error in ReadLater.add()');
            }

            return true;
        } catch (error) {
            console.log('%cReadLater', 'color: #faa', 'error adding');
        }

        return false;
    }

    static async remove(pageId: number): Promise<boolean> {
        try {
            const res: Response = await fetch(this.apiUrl + pageId, {
                method: 'DELETE',
                cache: 'no-cache',
            });

            if (!res.ok) {
                throw new Error('Internal server error in ReadLater.remove()');
            }

            return true;
        } catch (error) {
            console.log('%cReadLater', 'color: #faa', 'error removing');
        }

        return false;
    }

    static async list(id: number): Promise<ReadLaterApiData> {
        try {
            const res: Response = await fetch(this.apiUrl + '?page=0&size=1000', {
                cache: 'no-cache',
            });

            if (!res.ok) {
                throw new Error('Internal server error in ReadLater.list()');
            }

            const data: ReadLaterResponse = await res.json();
            const suggested: ReadLaterApi = data.content.length && data.content[0].pageId !== id ? data.content[0]
                : (data.content.length > 1 ? data.content[1] : null)!;

            return  {
                list: data.content.map((element: ReadLaterApi) => element.pageId),
                suggested: suggested,
                total: data.totalElements,
            }
        } catch (error) {
            console.log('%cReadLater', 'color: #faa', 'error getting list');
        }

        return  {
            list: [],
            suggested: null,
            total: 0,
        };
    }
}

export interface ReadLaterApi {
    title: string;
    lead: string;
    imageUrl: string;
    author: string;
    pageUrl: string;
    pageId: number;
    id: null;
    mainTag: string;
    mainTagLink: string;
    createDate: string;
}

export interface ReadLaterResponse {
    number: number;
    last: boolean;
    size: number;
    totalpages: number;
    content: ReadLaterApi[];
    first: boolean;
    totalElements: number;
}

export interface ReadLaterApiData {
    list: number[];
    suggested: ReadLaterApi | null;
    total: number;
}